// putting router guards functions here

import store from './store/index'

const uploadLetter = (to, from, next) => {
  const uploadModule = store.state.letter.upload

  if (uploadModule.valid && !!uploadModule.folderId) {
    next({ name: 'previewLetter' })
  } else {
    next()
  }
}

const previewLetter = (to, from, next) => {
  const uploadModule = store.state.letter.upload

  if (uploadModule.valid && !!uploadModule.folderId) {
    next()
  } else {
    next({ name: 'uploadLetter' })
  }
}

const deliveryLetter = (to, from, next) => {
  // TODO: put condition that will check the sender and recipients data
  next()
}

const orderList = (to, from, next) => {
  if (!store.getters.isLoggedIn) {
    next({ name: 'landing' })
  } else {
    next()
  }
}

const approveLetter = (to, from, next) => {
  if (!store.state.letter.delivery.deliveryDate) {
    next({ name: 'delivery' })
  } else {
    next()
  }
}

const approveSenderInfo = (to, from, next) => {
  if (!store.state.letter.delivery.deliveryDate) {
    next({ name: 'delivery' })
  } else {
    next()
  }
}

const approveStatus = (to, from, next) => {
  if (
    store.state.letter.pay.paymentMethod === 'none' &&
    !sessionStorage.getItem('orderPlaced')
  ) {
    next({ name: 'contactInformation' })
  } else {
    if (Object.keys(to.query).length) {
      const transactionObj = to.query

      switch (transactionObj.responseCode) {
        case 'OK':
          store.commit('letter/pay/SET_PAYMENT_STATUS', 'processing')
          store.commit(
            'letter/pay/SET_TRANSACTION_ID',
            transactionObj.transactionId
          )
          next()
          break
        case 'Cancel':
          store.commit('letter/pay/RESET_TRANSACTION_STATES')
          store.commit(
            'SET_MAILOUT_CURRENT_ROUTE',
            '/letter/pay/approve-contact-letter'
          )
          next({ name: 'contactInformation' })
          break
        default:
          next({ name: 'contactInformation' })
          break
      }
    } else {
      next()
    }
  }
}

const redirectToV1 = productType => {
  const existingProduct = localStorage.getItem('se-web2print-serviceType')
  const serviceType = `"${productType}"`

  if (!existingProduct || existingProduct !== serviceType) {
    Object.keys(localStorage).forEach(variable => {
      if (variable.includes('se-web2print-')) {
        localStorage.removeItem(variable)
      }
    })

    localStorage.setItem('se-web2print-serviceType', serviceType)
  }

  //NOTE: this wont work on local try to deploy to AT to test
  if (!store.getters.isBusinessUser) {
    location.href = process.env.VUE_APP_W2P_OLD_RECIPIENTS_PUBLIC_URL
  } else {
    location.href = process.env.VUE_APP_W2P_OLD_RECIPIENTS_COMPANY_URL
  }
}

const redirectToExternal = url => {
  location.href = url
}

const redirectLearnMoreLink = () => {
  if (store.state.lang === 'en') {
    location.href = process.env.VUE_APP_LEARN_MORE_URL_EN
  } else {
    location.href = process.env.VUE_APP_LEARN_MORE_URL_SE
  }
}

export {
  previewLetter,
  uploadLetter,
  deliveryLetter,
  approveLetter,
  approveSenderInfo,
  approveStatus,
  orderList,
  redirectToV1,
  redirectLearnMoreLink,
  redirectToExternal
}
